import { Box, IconButton, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import DataTable from 'components/DataTable';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Tooltip from '@material-ui/core/Tooltip';
import { getTextWidth } from 'utils';

const headCells = [
  { id: 'productName', label: 'Nom Produit', sortable: false },
  { id: 'image', label: 'Image', sortable: false },
  { id: 'description', label: 'Description', sortable: false },
  { id: 'level', label: 'Niveau', sortable: true },
  { id: 'courseType', label: 'Type cours', sortable: true },
  { id: 'addresses', label: 'Lieu prestation', sortable: false },
  { id: 'slots', label: 'Places', sortable: true },
  { id: 'duration', label: 'Durée', sortable: true },
  { id: 'age', label: 'Âge', sortable: true },
  { id: 'price', label: 'Prix TTC', sortable: true },
  { id: 'employees', label: 'Moniteurs', sortable: true },
  { id: 'edit', label: 'Editer', sortable: true },
];

function ActivitiesTable({ data, loading, onEditClick, onRemoveClick, seasonPrice }) {
  const theme = useTheme();

  const status = {
    blocked: {
      color: theme.palette.warning.main,
      label: 'Bloquée',
    },
    enabled: {
      color: theme.palette.secondary.main,
      label: 'Online',
    },
    disabled: {
      color: theme.palette.tertiary.main,
      label: 'Offline',
    },
  };

  const NormalizedData = Array.from(data).map((service, index) => ({
    ...service,
    productName: {
      component: (
        <>
          {getTextWidth(service.productName, theme.typography.h1.font) > 250 ? (
            <Tooltip title={service.productName}>
              <Typography noWrap style={{ color: theme.palette.primary.main, fontSize: 14 }}>
                {service.productName}
              </Typography>
            </Tooltip>
          ) : (
            <Typography noWrap style={{ color: theme.palette.primary.main, fontSize: 14 }}>
              {service.productName}
            </Typography>
          )}
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: theme.palette.blue.light,
              borderRadius: 5,
              borderStyle: 'thin',
              borderWidth: 1,
            }}
          >
            <FiberManualRecordIcon fontSize="small" style={{ color: status[service.status]?.color }} />
            <Typography>{status[service.status]?.label}</Typography>
          </Box>
        </>
      ),
    },
    description: (
      <Typography noWrap style={{ fontSize: 14, maxWidth: 225 }}>
        {service.description}
      </Typography>
    ),
    duration: service.duration + ' min',
    age: service.minAge + ' - ' + service.maxAge + ' ans',
    price: (seasonPrice ? service.priceLowSeason : service.priceHighSeason) + ' € ',
    level: service.level.label,
    courseType: service.courseType.label,
    addresses: service.employeesAndAddresses.map((empAdd) => empAdd.address.title),
    employees: [
      ...new Set(
        service.employeesAndAddresses.map((empAdd) =>
          empAdd.employee.first_name.concat(' ', empAdd.employee.last_name),
        ),
      ),
    ],
    edit: {
      component: (
        <div style={{ display: 'flex' }}>
          <IconButton size="small" onClick={(event) => onEditClick(event, service)}>
            <EditIcon color="primary" />
          </IconButton>
          <IconButton size="small" onClick={(event) => onRemoveClick(event, index)}>
            <DeleteIcon style={{ color: theme.palette.tertiary.main }} />
          </IconButton>
        </div>
      ),
    },
    image: {
      component: service.ImgPath ? <img src={service.ImgPath} alt={"image de l'activité " + service.name} /> : <span />,
    },
  }));

  return <DataTable headCells={headCells} data={NormalizedData} loading={loading} />;
}

export default ActivitiesTable;
